import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreensizeService {

  constructor() { }

  getScreenSize(): { width: number; height: number } {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  }
}
